import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { useSettings, useCategories, waLink } from "../../lib/api";

export const Footer = () => {
  const s = useSettings();
  const { categories } = useCategories();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-[#07090e] text-slate-300">
      <div className="container-x grid gap-12 py-20 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo />
          <p className="font-display mt-6 text-2xl font-bold uppercase leading-tight text-white">Driving innovation with <span className="text-sky-400">rubber precision.</span></p>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
            Manufacturer of precision rubber components for OEMs, distributors and traders across India. Since 2012.
          </p>
          <div className="mt-8 space-y-3 text-sm">
            <a href={`tel:${s.phone}`} data-testid="footer-phone" className="flex items-center gap-3 hover:text-white"><Phone className="h-4 w-4 text-sky-400" />{s.phone}</a>
            <a href={`mailto:${s.email}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-white"><Mail className="h-4 w-4 text-sky-400" />{s.email}</a>
            <a href={waLink(s.whatsapp)} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 hover:text-white"><MessageCircle className="h-4 w-4 text-sky-400" />WhatsApp us</a>
            <p className="flex items-start gap-3"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-sky-400" />{s.address}</p>
          </div>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow text-slate-400">Products</p>
          <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-2.5 text-sm">
            {categories.map((c) => (
              <li key={c.id}><Link to={`/products/${c.slug}`} className="hover:text-sky-400">{c.name}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow text-slate-400">Company</p>
          <ul className="mt-5 space-y-2.5 text-sm">
            <li><Link to="/about" className="hover:text-sky-400">About us</Link></li>
            <li><Link to="/industries" className="hover:text-sky-400">Industries we serve</Link></li>
            <li><Link to="/#infrastructure" className="hover:text-sky-400">Infrastructure</Link></li>
            <li><Link to="/#quality" className="hover:text-sky-400">Quality & certifications</Link></li>
            <li><Link to="/#downloads" className="hover:text-sky-400">Downloads</Link></li>
            <li><Link to="/contact" className="hover:text-sky-400">Contact / RFQ</Link></li>
          </ul>
        </div>
      </div>
      <div className="font-display pointer-events-none select-none whitespace-nowrap px-4 text-center text-[22vw] font-black uppercase leading-[0.78] text-white/[0.04]" aria-hidden>
        Autocrat
      </div>
      <div className="container-x flex flex-col justify-between gap-3 border-t border-slate-800 py-6 text-xs text-slate-400 sm:flex-row">
        <p>© {new Date().getFullYear()} Autocrat Rubber Industries. All rights reserved.</p>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white">Admin login</Link>
      </div>
    </footer>
  );
};
